export default "__VITE_ASSET__iixzn6kJ__"